module.exports = __webpack_public_path__ + "static/media/environment.b78dc199.svg";